/* modal設定*/
// $('.bt_modal_open').on('click', function () {
//     var target = $(this).data('target');
//     var modal = document.getElementById(target);
//     scrollPosition = $(window).scrollTop();
//     $('body').addClass('fixed').css({ top: -scrollPosition });
//     $(modal).fadeIn();
//     return false;
// });

// $('.modal_win').on('click', function () {
//     var target = $(this).data('target');
//     var modal = document.getElementById(target);
//     scrollPosition = $(window).scrollTop();
//     $('body').addClass('fixed').css({ top: -scrollPosition });
//     $(modal).fadeIn();
//     return false;
// });

// $('.bt_modal_close').on('click', function () {
//     $('body').removeClass('fixed');
//     window.scrollTo(0, scrollPosition);
//     $('.js-modal').fadeOut();
//     return false;
// });

/* menu設定*/
const body = document.body;
const ch_Win = 980;
var timer = '';
window.onresize = function () {
    if (timer) {
        clearTimeout(timer);
    }
    timer = setTimeout(function () {
        var win_size = document.documentElement.clientWidth;
        if (win_size < ch_Win) {
            /*			alert('SP size');*/
            nav?.classList.remove('active');
        } else {
            /*			alert('PC size');*/
            body?.classList.remove('fixed');
            menu?.classList.remove('is-active');
        }
    }, 200);
};

/* menu設定　PC用*/
const nav = document.querySelector('.nav');
document.addEventListener('click', e => {
    if (e.target.closest('.btn')) {
        nav?.classList.contains('active') ? nav?.classList?.remove('active') : nav?.classList?.add('active');
    } else {
        nav?.classList?.remove('active');
    }
});

/* menu設定　SP用*/
document.querySelector('#menu-btn')?.addEventListener('click', function () {
    var win_size = document.documentElement.clientWidth;
    if (win_size < ch_Win) {
        document.querySelector('.menu').classList.toggle('is-active');
        body?.classList.add('fixed');
    }
});

const spcross = document.querySelector('#sp-cross');
const menu = document.querySelector('.menu');
spcross?.addEventListener('click', function () {
    menu?.classList.toggle('is-active');
    body?.classList.remove('fixed');
});
